import { useGlobalSearchProductCodeQuery } from '../../../services/modules/global-search/globalSearchProductCode.queries';
import { ProductSearchResultItem } from '../globalSearch.types';

interface UseGlobalSearchProductCodeParams {
  isEnabled: boolean;
  query: string;
}

const useGlobalSearchProductCode = ({ isEnabled, query }: UseGlobalSearchProductCodeParams) => {
  const { data, isFetching } = useGlobalSearchProductCodeQuery(
    { q: query },
    { enabled: isEnabled },
  );

  const items = (data?.items ?? []).filter(
    (item): item is ProductSearchResultItem => item.entityType === 'product',
  );

  return { items, isFetching };
};

export default useGlobalSearchProductCode;
